"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioRootDataAttributes = void 0;
let RadioRootDataAttributes = exports.RadioRootDataAttributes = /*#__PURE__*/function (RadioRootDataAttributes) {
  /**
   * Present when the radio is checked.
   */
  RadioRootDataAttributes["checked"] = "data-checked";
  /**
   * Present when the radio is not checked.
   */
  RadioRootDataAttributes["unchecked"] = "data-unchecked";
  /**
   * Present when the radio is disabled.
   */
  RadioRootDataAttributes["disabled"] = "data-disabled";
  /**
   * Present when the radio is readonly.
   */
  RadioRootDataAttributes["readonly"] = "data-readonly";
  /**
   * Present when the radio is required.
   */
  RadioRootDataAttributes["required"] = "data-required";
  /**
   * Present when the radio is in valid state (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["valid"] = "data-valid";
  /**
   * Present when the radio is in invalid state (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["invalid"] = "data-invalid";
  /**
   * Present when the radio has been touched (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["touched"] = "data-touched";
  /**
   * Present when the radio's value has changed (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["dirty"] = "data-dirty";
  /**
   * Present when the radio is checked (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["filled"] = "data-filled";
  /**
   * Present when the radio is focused (when wrapped in Field.Root).
   */
  RadioRootDataAttributes["focused"] = "data-focused";
  return RadioRootDataAttributes;
}({});